import { PermissionList } from '@/libs/defaultList'

export default [
    // *===================Bi Tool Report============================---*
    {
        path: '/reports/visitwebsite',
            name: 'bireport',
            component: () => import('@/views/reports/visitwebsite.vue'),
            meta: {
                pageTitle: 'BI Tools',
                breadcrumb: [
                    {
                        text: 'BI Tool Report',
                        active: true,
                    },
                ],
                permission: PermissionList.Reporting_View
            },
    }
    ]